"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _consts = require("./../consts.js");

var __jsx = _react.default.createElement;

var Wrapper = _styledComponents.default.div.withConfig({
  displayName: "OzSlider__Wrapper",
  componentId: "sc-oqd45u-0"
})(["\n  text-align: left;\n\n  &, & * {\n    box-sizing: border-box;\n  }\n"]);

var Container = _styledComponents.default.div.withConfig({
  displayName: "OzSlider__Container",
  componentId: "sc-oqd45u-1"
})(["\n  position: relative;\n  display: block;\n  width: ", ";\n  height: ", ";\n  max-width: 100%;\n  display: flex;\n  flex-direction: column;\n  // border: 1px solid red;\n  // background-color: red;\n"], function (props) {
  return props.width;
}, function (props) {
  return props.height;
});

var Label = _styledComponents.default.div.withConfig({
  displayName: "OzSlider__Label",
  componentId: "sc-oqd45u-2"
})(["\n  margin-top: 20px;\n  margin-bottom: 5px;\n  font-size: 11px;\n  font-weight: 300;\n"]);

var Slider = _styledComponents.default.input.withConfig({
  displayName: "OzSlider__Slider",
  componentId: "sc-oqd45u-3"
})(["\n  --c: ", "; /* active color */\n  --g: 2px; /* the gap */\n  --l: 3px; /* line thickness*/\n  --s: 7px; /* thumb size*/\n    \n  height: 11px; /* needed for Firefox*/\n  -webkit-appearance: none;\n  -moz-appearance: none;\n  appearance: none;\n  background: none;\n  cursor: pointer;\n  overflow: hidden;\n\n\n  /* chromium */\n  &[type=\"range\" i]::-webkit-slider-thumb{\n    height: var(--s);\n    aspect-ratio: 1;\n    background: var(--c);\n    border-radius: 3px;\n    box-shadow: 0px 1px 2px #687FE239;\n    border-image: linear-gradient(90deg,var(--c) 50%,#ababab 0) 1/0 100vw/0 calc(100vw + var(--g));\n    clip-path:\n      polygon(\n        0     calc(50% + var(--l)/2),\n        -100vw calc(50% + var(--l)/2),\n        -100vw calc(50% - var(--l)/2),\n        0     calc(50% - var(--l)/2),\n        0 0,100% 0,\n        100%  calc(50% - var(--l)/2),\n        100vw calc(50% - var(--l)/2),\n        100vw calc(50% + var(--l)/2),\n        100%  calc(50% + var(--l)/2),\n        100% 100%,0 100%);\n    -webkit-appearance: none;\n    appearance: none;\n  }\n  \n  /* Firefox */\n  &[type=\"range\"]::-moz-range-thumb {\n    height: var(--s);\n    width: var(--s);\n    background: var(--c);\n    border-radius: 3px;\n    box-shadow: 0px 1px 2px #687FE239;\n    // box-shadow: 0 0 0 2px inset #fff, 0px 0px 0 0 black;\n    border-image: linear-gradient(90deg,var(--c) 50%,#ababab 0) 1/0 100vw/0 calc(100vw + var(--g));\n    clip-path:\n      polygon(\n        0     calc(50% + var(--l)/2),\n        -100vw calc(50% + var(--l)/2),\n        -100vw calc(50% - var(--l)/2),\n        0     calc(50% - var(--l)/2),\n        0 0,\n        100% 0,\n        100%  calc(50% - var(--l)/2),\n        100vw calc(50% - var(--l)/2),\n        100vw calc(50% + var(--l)/2),\n        100%  calc(50% + var(--l)/2),\n        100% 100%,\n        0 100%\n      );\n    -moz-appearance: none;\n    appearance: none;\n  }\n\n"], function (props) {
  return !props.disabled ? _consts.CHETWODEBLUE : "#dedede";
});

var Value = _styledComponents.default.input.withConfig({
  displayName: "OzSlider__Value",
  componentId: "sc-oqd45u-4"
})(["\n  position: absolute;\n  top: 1px;\n  left: ", "%;\n  margin-left: -8px;\n  width: 30px;\n  background: ", ";\n  text-align: center;\n  border: 0px;\n  border-radius: 3px;\n  padding: 3px 2px;\n  font-size: 11px;\n"], function (props) {
  return 0 + props.value / 100 * 94.5;
}, _consts.LILAC);

var Scale = _styledComponents.default.div.withConfig({
  displayName: "OzSlider__Scale",
  componentId: "sc-oqd45u-5"
})(["\n  display: flex;\n  justify-content: space-between;\n  width: 100%;\n  height: 14px;\n  // background: lime;\n  margin-top: 7px;\n"]);

var ScaleWrap = _styledComponents.default.div.withConfig({
  displayName: "OzSlider__ScaleWrap",
  componentId: "sc-oqd45u-6"
})(["\n  width: 1px;\n"]);

var ScaleVal = _styledComponents.default.div.withConfig({
  displayName: "OzSlider__ScaleVal",
  componentId: "sc-oqd45u-7"
})(["\n  width: 30px;\n  margin-left: -15px;\n  text-align: center;\n  font-size: 9px;\n  line-height: 10px;\n"]);

var OzSlider = function OzSlider(_ref) {
  var _ref$variant = _ref.variant,
      variant = _ref$variant === void 0 ? "default" : _ref$variant,
      label = _ref.label,
      _ref$value = _ref.value,
      value = _ref$value === void 0 ? 0 : _ref$value,
      _onChange = _ref.onChange,
      _ref$width = _ref.width,
      width = _ref$width === void 0 ? "260px" : _ref$width,
      _ref$height = _ref.height,
      height = _ref$height === void 0 ? "34px" : _ref$height,
      _ref$min = _ref.min,
      min = _ref$min === void 0 ? 0 : _ref$min,
      _ref$max = _ref.max,
      max = _ref$max === void 0 ? 100 : _ref$max,
      _ref$disabled = _ref.disabled,
      disabled = _ref$disabled === void 0 ? false : _ref$disabled,
      _ref$required = _ref.required,
      required = _ref$required === void 0 ? false : _ref$required;
  return __jsx(Wrapper, null, label ? __jsx(Label, null, label, " ", required ? "*" : "") : null, __jsx(Container, {
    width: width,
    height: height
  }, __jsx(Scale, null, __jsx(ScaleWrap, null, __jsx(ScaleVal, null, min)), __jsx(ScaleWrap, null, __jsx(ScaleVal, null, (max - min) / 4 * 1)), __jsx(ScaleWrap, null, __jsx(ScaleVal, null, (max - min) / 4 * 2)), __jsx(ScaleWrap, null, __jsx(ScaleVal, null, (max - min) / 4 * 3)), __jsx(ScaleWrap, null, __jsx(ScaleVal, null, max))), __jsx(Slider, {
    disabled: disabled ? "disabled" : null,
    type: "range",
    min: min,
    max: max,
    value: value ? value : 0,
    onChange: function onChange(val) {
      if (_onChange) {
        _onChange(val.target.value);
      }

      ;
    }
  }), __jsx(Value, {
    placeholder: "0",
    value: value ? value : "",
    onChange: function onChange(val) {
      if (val.target.value >= min && val.target.value <= max) {
        if (_onChange) {
          _onChange(val.target.value);
        }

        ;
      }
    }
  })));
};

var _default = OzSlider;
exports.default = _default;